import { Component, Inject, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ButtonComponent } from '@shared/components/button/button.component';

@Component({
  selector: 'app-terms-and-conditions-dialog',
  standalone: true,
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    ButtonComponent,
  ],
  templateUrl: './terms-and-conditions-dialog.component.html',
  styleUrl: './terms-and-conditions-dialog.component.css',
})
export class TermsAndConditionsDialogComponent {
  isMobile!: boolean;
  readonly dialogRef = inject(MatDialogRef<TermsAndConditionsDialogComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: { isMobile: boolean }) {
    this.isMobile = data.isMobile || false;
  }
}
